import { ChatRole } from "../conversation/types";
const isRecord = (value) => typeof value === "object" && value !== null;
export function isRulebookHudSnapshot(value) {
    return isRecord(value) && isRecord(value["meters"]);
}
/**
 * Id of the currently displayed bot message — the selected alternative (`altMsgs[altMsgPosition]`)
 * when in range, else the last bot message in `conversation`. Same branch pick as
 * `selectDisplayedRulebookSnapshot` but without the `rulebook` meta requirement.
 */
export function selectDisplayedMessageId({ conversation, altMsgs, altMsgPosition, }) {
    const displayedAlt = altMsgs.length > 0 && altMsgPosition >= 0 && altMsgPosition < altMsgs.length ? altMsgs[altMsgPosition] : undefined;
    for (let index = conversation.length; index >= 0; index -= 1) {
        const message = index === conversation.length ? displayedAlt : conversation[index];
        if (message?.role === ChatRole.BOT) {
            return message.id;
        }
    }
    return undefined;
}
/**
 * Pick the rulebook snapshot the HUD should display. The displayed branch is the main
 * `conversation` plus the currently selected alternative (`altMsgs[altMsgPosition]`) when
 * alternatives exist. Walking backwards, the first bot message carrying `rulebook` meta is
 * the snapshot; when the displayed tail bot message has no meta the snapshot is flagged as
 * `isPastState` so the HUD can mark it stale.
 */
export default function selectDisplayedRulebookSnapshot({ conversation, altMsgs, altMsgPosition, rulebookId, }) {
    // Mirrors Chat.tsx `messagesToRender`: an alt is displayed only while `altMsgPosition` is in
    // range. During a pending regenerate (`altMsgPosition >= altMsgs.length`) no alt is appended,
    // so the HUD shows the last snapshot before the regenerated turn (flagged `isPastState`).
    const displayedAlt = altMsgs.length > 0 && altMsgPosition >= 0 && altMsgPosition < altMsgs.length ? altMsgs[altMsgPosition] : undefined;
    const isRegeneratePending = altMsgs.length > 0 && altMsgPosition >= altMsgs.length;
    let lastBotMessageId;
    for (let index = conversation.length; index >= 0; index -= 1) {
        const message = index === conversation.length ? displayedAlt : conversation[index];
        if (!message || message.role !== ChatRole.BOT) {
            continue;
        }
        lastBotMessageId ??= message.id;
        const meta = message["rulebook"];
        if (isRulebookHudSnapshot(meta) && (rulebookId === undefined || meta.rulebook_id === rulebookId)) {
            return {
                meta,
                messageId: message.id,
                isPastState: message.id !== lastBotMessageId || isRegeneratePending,
            };
        }
    }
    return null;
}
